import { Component, Host, h, Prop, ComponentInterface } from '@stencil/core';
import { PredefinedColors } from '../../interface';

@Component({
    tag: 'rs-icon',
    styleUrl: 'icon.css',
    shadow: true
})
export class Icon implements ComponentInterface {
    /**
     * Name of the icon
     *
     */
    @Prop() name: string = '';

    /**
     * Color of the icon
     */
    @Prop() color: PredefinedColors;

    /**
     * Size of the icon in pixels
     */
    @Prop() size: number;


    render() {
        return (
            <Host>
                <span style={{
                    'color': this.color !== undefined ? `var(--rs-color-${this.color})` : '',
                    'font-size': this.size !== undefined ? `${this.size}px` : ''
                }}
                      class={`rs-icon-${this.name}`}/>
            </Host>
        );
    }
}